import odata from 'odata-client';
import {
  DELETE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_ERROR,
  DELETE_CUSTOMER_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import { getServiceUrl, getDefaultHeader } from '../../utils';
import RESOURCES from '../../api/resources';
import { showNotification } from '../notification';
/*import getToken from '../user/getToken';*/

export const tokenExpired = () => ({
  type: TOKEN_EXPIRED
});

export const deleteCustomerRequest = () => ({
  type: DELETE_CUSTOMER_REQUEST
});

export const deleteCustomerError = errorOrResults => ({
  type: DELETE_CUSTOMER_ERROR,
  error: errorOrResults.message
});

export const deleteCustomerSuccess = payload => ({
  type: DELETE_CUSTOMER_SUCCESS,
  payload
});

export default customer => async (dispatch, getState) => {
  dispatch(deleteCustomerRequest());

  const query = odata({ service: getServiceUrl() }).resource(RESOURCES.Customers, customer.ID);
  const errorOrResult = await query.delete({
    headers: {
      Authorization: `Bearer ${getState().user.token}`,
      ...getDefaultHeader()
    }
  })
    .then(resp => resp)
    .then(res => {
      const ok = res.statusCode <= 299 && res.statusCode >= 200;
      if (res.statusCode === 500) {
        const errorKey = "GENERAL_SERVER_ERROR";
        return new Error(errorKey);
      } else if (!ok) {
        console.log("delete customer api error", res.toJSON());
        const body = JSON.parse(res.body);
        const { Error: { Message } } = body
        const errorKey = res.statusCode === 401 ? `401: ${Message}` : `${Message}`;
        return new Error(errorKey);
      } else {
        return customer;
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      dispatch(showNotification("Request probably timed out.", "error"))
    });

  if (errorOrResult instanceof Error) {
    dispatch(deleteCustomerError(errorOrResult, DELETE_CUSTOMER_ERROR));
    if (errorOrResult.message.split(":")[0] === "401") {
      dispatch(tokenExpired());
      dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
    }
    console.log("CODE ERROR: ", errorOrResult.message);
    dispatch(showNotification(errorOrResult.message, "error"))
    return errorOrResult;
  } else {
    dispatch(showNotification("SUCCESSFUL_DELETE", "success"))
  }

  dispatch(deleteCustomerSuccess(errorOrResult));

  return errorOrResult;
};